'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useId } from 'react';
import PopoverLayer from './PopoverLayer';
import { PopoverContentCoreProps } from './types';
interface PopoverContextInterface extends PopoverContentCoreProps {
  triggerId: string;
  contentId: string;
  openPopover: () => void;
  hidePopover: () => void;
}
const PopoverContext = createContext<PopoverContextInterface>({
  triggerId: '',
  contentId: '',
  openPopover: () => {},
  hidePopover: () => {}
});
interface PopoverProviderProps extends PopoverContentCoreProps {
  children: React.ReactNode;
  className?: string;
}
const PopoverProvider = t0 => {
  const $ = _c(20);
  let children;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
  }
  const triggerId = useId();
  const contentId = useId();
  let t1;
  if ($[4] !== contentId) {
    t1 = () => {
      document.getElementById(contentId)?.showPopover?.();
    };
    $[4] = contentId;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const openPopover = t1;
  let t2;
  if ($[6] !== contentId) {
    t2 = () => {
      const content = document.getElementById(contentId);
      content?.hidePopover?.();
    };
    $[6] = contentId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const hidePopover = t2;
  let t3;
  if ($[8] !== contentId || $[9] !== hidePopover || $[10] !== openPopover || $[11] !== props || $[12] !== triggerId) {
    t3 = {
      triggerId,
      contentId,
      openPopover,
      hidePopover,
      ...props
    };
    $[8] = contentId;
    $[9] = hidePopover;
    $[10] = openPopover;
    $[11] = props;
    $[12] = triggerId;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== children || $[15] !== className) {
    t4 = <PopoverLayer className={className}>{children}</PopoverLayer>;
    $[14] = children;
    $[15] = className;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== t3 || $[18] !== t4) {
    t5 = <PopoverContext.Provider value={t3}>{t4}</PopoverContext.Provider>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
};
const usePopover = () => {
  const context = useContext(PopoverContext);
  if (!context) {
    throw new Error("usePopover must be used within PopoverProvider");
  }
  return context;
};
export { PopoverProvider, usePopover };